module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('table', {
    staticClass: "table"
  }, [_c('tr', [_c('th', [_vm._v("\n        Nazwa\n        "), _c('sorting', {
    attrs: {
      "sort": _vm.meta.sort,
      "key-for": 'name',
      "direction": _vm.meta.direction
    },
    on: {
      "change-order": _vm.changeOrder
    }
  })], 1), _vm._v(" "), _c('th', [_vm._v("\n        Grupa publiczna\n        "), _c('sorting', {
    attrs: {
      "sort": _vm.meta.sort,
      "key-for": 'public',
      "direction": _vm.meta.direction
    },
    on: {
      "change-order": _vm.changeOrder
    }
  })], 1), _vm._v(" "), _c('th', [_vm._v("\n        Status\n        "), _c('sorting', {
    attrs: {
      "sort": _vm.meta.sort,
      "key-for": 'status',
      "direction": _vm.meta.direction
    },
    on: {
      "change-order": _vm.changeOrder
    }
  })], 1), _vm._v(" "), _c('th', [_vm._v("\n        Akcje\n      ")])]), _vm._v(" "), _vm._l((_vm.items), function(item) {
    return _c('tr', [_c('td', [_c('a', {
      staticClass: "main-link",
      on: {
        "click": function($event) {
          _vm.$router.push({
            name: 'admin.email-groups.show',
            params: {
              id: item.id
            }
          })
        }
      }
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('span', {
      staticClass: "gray"
    }, [_vm._v("(" + _vm._s(item.total_emails) + ")")])]), _vm._v(" "), _c('td', [_c('span', [_vm._v(_vm._s(item.public ? 'Tak' : 'Nie'))])]), _vm._v(" "), _c('td', [_c('span', [_vm._v(_vm._s(item.status == 1 ? 'Aktywna' : 'Nie aktywna'))])]), _vm._v(" "), _c('td', {
      staticClass: "actions"
    }, [_c('ui-button', {
      attrs: {
        "type": "flat",
        "icon": "mode_edit",
        "color": "primary"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.$router.push({
            name: 'admin.email-groups.edit',
            params: {
              id: item.id
            }
          })
        }
      }
    }, [_vm._v("Edytuj")]), _vm._v(" "), _c('ui-button', {
      attrs: {
        "type": "flat",
        "icon": "highlight_off",
        "color": "danger"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.remove(item)
        }
      }
    }, [_vm._v("Usuń")])], 1)])
  })], 2), _vm._v(" "), _c('basic-pagination', {
    attrs: {
      "meta": _vm.meta
    },
    on: {
      "pagination-page": _vm.changePage,
      "pagination-limit": _vm.changeLimit
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-505a55bc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/email-groups/List.vue
// module id = 258
// module chunks = 0